export default __webpack_public_path__ + "0bdc8d7be66fa361bffe5c3a1ee9344b.jpg";